import React from 'react';
import { AULink } from 'components/AULink';
import { clearAll, deleteSessionStorage } from 'helpers/storage';
import { SEGMENT_IO_ANONYMOUS_ID, SPLIT_IO_USER_KEY_COOKIE } from 'au-js-sdk/lib/services/split.io/constants';
import { SEGMENT_TRACKING_PREFERENCES_COOKIE } from 'components/SegmentConsentBanner';
import { ADDRESS_SESSION_KEYS } from 'constants/storage';
import { customerLogout } from 'services/magenum/customer';

interface LogoutButtonProps {
  className?: string;
  id: string;
}

const LogoutButton = ({ className, id }: LogoutButtonProps): React.JSX.Element => {
  const onLogout = e => {
    e.preventDefault();

    // Leave the segment anonymous id so that we can track a user between authenticated and anonymous
    clearAll([SEGMENT_IO_ANONYMOUS_ID, SPLIT_IO_USER_KEY_COOKIE, SEGMENT_TRACKING_PREFERENCES_COOKIE]);

    // remove the session storage keys if they exist
    ADDRESS_SESSION_KEYS.forEach((key: string) => deleteSessionStorage(key));

    customerLogout()
      .then(() => {
        window.location.href = process.env.GATSBY_SITE_URL; 
      })
      .catch(e => {
        console.error(e);
      });
  };

  return (
    <AULink id={id} path="#" role="button" className={className} onClick={onLogout}>
      Logout
    </AULink>
  );
};

export default LogoutButton;
